import { generateDeleteActionCreator, generateReadOneActionCreator, generateUpdateActionCreator } from '../crudActionCreators';
import ACTION_NAMES from 'actions/ACTION_NAMES';
import routes from 'actions/routes';

export default {
    readAddon: generateReadOneActionCreator(routes.API_PRODUCT_ADDONS, ACTION_NAMES.PRODUCT_ADDONS),
    updateAddon: generateUpdateActionCreator(routes.API_PRODUCT_ADDONS, ACTION_NAMES.PRODUCT_ADDONS),
    deleteAddon: generateDeleteActionCreator(routes.API_PRODUCT_ADDONS, ACTION_NAMES.PRODUCT_ADDONS)
}
